import styled from "styled-components";

import { DATA_E2E_KEY, IStyledAttributes } from "@ryde/shared";
import { MOBILE_BREAKPOINT } from "@ryde/theme";

export const NotificationsDrawerListStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "notifications-drawer-list",
  },
)`
  padding: 40px 0;
  display: flex;
  flex-flow: column;
  align-content: center;
  gap: 25px;
  margin-inline-start: -24px;
  align-items: center;

  .NotificationsDrawer-NoNotificationFound {
    font-size: 24px;
  }

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    margin-inline-start: initial;
  }
`;
